import { render, staticRenderFns } from "./kategoricustomer.vue?vue&type=template&id=075bf7e0&scoped=true"
import script from "./kategoricustomer.vue?vue&type=script&lang=js"
export * from "./kategoricustomer.vue?vue&type=script&lang=js"
import style0 from "./kategoricustomer.vue?vue&type=style&index=0&id=075bf7e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075bf7e0",
  null
  
)

export default component.exports